module.exports = __webpack_public_path__ + "media/images/default/noimage-7ac364a87207348e7a10dde69f17a4f8.png";